module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("hgplB"))).then(() => parcelRequire('1iHdE'));